import React, { createContext, useState } from 'react';
import { ContextProps, ContextShape, NavigationCategory } from '../types';

const HeaderContext = createContext({} as ContextShape);

const HeaderProvider = ({
  isAdmin,
  accountLink,
  accountLinkLabel,
  cartItems,
  ordersLink,
  ordersLinkLabel,
  cartLink,
  cartLinkLabel,
  children,
  businessUnits,
  selectedBusinessUnit,
  quotes,
  onBusinessUnitChange,
  onStoreChange,
  addToCart,
  addToCartDisabled,
}: React.PropsWithChildren<ContextProps>) => {
  const [navigationLevel, setNavigationLevel] = useState<NavigationCategory[]>([]);
  const [showMenu, setShowMenu] = useState(false);
  const [showQuickOrder, setShowQuickOrder] = useState(false);

  const showHeaderMenu = () => {
    setShowMenu(true);
  };

  const hideHeaderMenu = () => {
    setShowMenu(false);
    setNavigationLevel([]);
  };

  const showQuickOrderMenu = () => {
    setShowQuickOrder(true);
  };

  const hideQuickOrderMenu = () => {
    setShowQuickOrder(false);
  };

  const removeCategory = () => {
    setNavigationLevel((array) => array.slice(0, -1));
  };

  const insertCategory = (category: NavigationCategory) => {
    setNavigationLevel((array) => [...array, category]);
  };

  return (
    <HeaderContext.Provider
      value={{
        isAdmin,
        cartItems,
        ordersLink,
        ordersLinkLabel,
        cartLink,
        cartLinkLabel,
        accountLink,
        accountLinkLabel,
        showQuickOrder,
        showMenu,
        navigationLevel,
        selectedBusinessUnit,
        businessUnits,
        quotes,
        onStoreChange,
        onBusinessUnitChange,
        insertCategory,
        removeCategory,
        showQuickOrderMenu,
        hideQuickOrderMenu,
        showHeaderMenu,
        hideHeaderMenu,
        addToCart,
        addToCartDisabled,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};
export { HeaderContext, HeaderProvider };
